import * as THREE from "three";

import Garden from '../../Garden';
import Bloom from '../Bloom';

export class RandomView extends THREE.Group implements GardenView {
    constructor() {
        super();

        var seed = 3225;
        function random() {
            var x = Math.sin(seed++) * 10000;
            return x - Math.floor(x);
        }
        // let count = 420; // CaptureA
        // let count = 480; // CaptureB
        // let count = 512;
        let count = 2048;
        for (let i = 0; i < count; i++) {

            let progress = i / count;

            let preset = Garden.PresetArray[Math.floor(random() * Garden.PresetArray.length)];
            let bloom = new Bloom(preset);
            let scale = .25 + random() * 2.;

            let size = 48; // A
            // let size = 48 + (16 * (1 - progress)); // B

            bloom.position.set(random() * size - (size / 2), progress * progress * 64, random() * size - (size / 2));
            bloom.scale.set(scale, scale, scale);
            bloom.rotation.y = random() * Math.PI * 126;
            this.add(bloom);
        }
    }
}